@if (pushMsg.msgData.newTicket === true) {
  <span class="font-bold">
    {{ 'snackbar.snackbar-ticket-msg.new.header' | transloco: { receiveDate: pushMsg.clientReceiveDate | date: 'mediumTime' } }}
  </span>
  <br />
  <span>
    {{ 'snackbar.snackbar-ticket-msg.new.text' | transloco: { ticketNr: pushMsg.msgData.ticketNr } }}
  </span>
}
@if (pushMsg.msgData.newTicket === false) {
  <span class="font-bold">
    {{ 'snackbar.snackbar-ticket-msg.edit.header' | transloco: { receiveDate: pushMsg.clientReceiveDate | date: 'mediumTime' } }}
  </span>
  <br />
  <span>
    {{ 'snackbar.snackbar-ticket-msg.edit.text' | transloco: { ticketNr: pushMsg.msgData.ticketNr } }}
  </span>
}
<br />
<a class="link-secondary" [routerLink]="commonRoutes.postlogin.tickets">
  {{ 'snackbar.snackbar-ticket-msg.link' | transloco }}
</a>
<br /><br />
